import { Outlet } from "react-router-dom";
import { useStateContext } from "../../contexts/ContextProvider";
import { useLogout } from "../../api/useLogout";

/**
 * L'enveloppe de l'espace hôtelier.
 *
 * Volontairement dépouillée, et sans la `Sidebar` du back-office : l'hôtelier
 * n'a que trois écrans, et aucune entrée de menu ne doit laisser croire qu'il
 * en existe d'autres.
 */
export default function EspaceLayout() {
    const { user } = useStateContext();
    const { logout } = useLogout();

    return (
        <div className="min-h-screen bg-gray-50">
            <header className="border-b border-gray-200 bg-white">
                <div className="mx-auto flex max-w-5xl items-center justify-between px-4 py-4 sm:px-6">
                    <div className="flex items-center gap-4">
                        <img
                            className="h-6 w-auto"
                            src="/images/logo-peace-and-work.png"
                            alt="Peace&Work"
                        />
                        <div className="border-l border-gray-200 pl-4">
                            <p className="text-sm font-medium text-gray-900">
                                {user.facility?.name ?? "Mon établissement"}
                            </p>
                            <p className="text-xs text-gray-500">Espace Peace&amp;Work</p>
                        </div>
                    </div>

                    <button
                        type="button"
                        onClick={() => { void logout(); }}
                        className="text-sm text-gray-500 underline-offset-2 hover:text-gray-900 hover:underline"
                    >
                        Se déconnecter
                    </button>
                </div>
            </header>

            <main className="mx-auto max-w-5xl px-4 py-8 sm:px-6">
                <Outlet />
            </main>
        </div>
    );
}
